import * as tslib_1 from "tslib";
import * as React from 'react';
import { StyledIconBase } from '../../StyledIconBase';
export var Send = React.forwardRef(function (props, ref) {
    var attrs = {
        "fill": "currentColor",
    };
    return (React.createElement(StyledIconBase, tslib_1.__assign({ iconAttrs: attrs, iconVerticalAlign: "middle", iconViewBox: "0 0 24 24" }, props, { ref: ref }),
        React.createElement("path", { d: "M21.426 11.095l-17-8A.999.999 0 1 0 3.03 4.242L4.969 12 3.03 19.758a.998.998 0 0 0 1.396 1.147l17-8a1 1 0 0 0 0-1.81zM5.481 18.197l1.09-4.36L13 12l-6.429-1.837-1.09-4.36L18.651 12l-13.17 6.197z", key: "k0" })));
});
Send.displayName = 'Send';
export var SendDimensions = { height: 24, width: 24 };
